import styled from '@emotion/styled';

import type { Gap } from '@hrworks/sui-shared/types';

const Container = styled.div(({ theme }) => ({
  padding: theme.eclipseTier1.spacing['32px'],
}));

const ColumnLayout = styled.div<{ rowGap?: Gap }>(({ rowGap, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: rowGap || theme.eclipseTier1.spacing['16px'],
}));

export const S = {
  Container,
  ColumnLayout,
} as const;
